import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { ProgressBarAndRouteStatus } from './ProgressBarAndRouteStatus';

function RouteItem({ route }) {
  const routeItemRef = useRef(null);

  return (
    <div
      data-routeid={route.id}
      className="route-item"
      ref={routeItemRef}
    >
      <ProgressBarAndRouteStatus route={route} />
    </div>
  );
}

RouteItem.propTypes = {
  route: PropTypes.object.isRequired
};

export default RouteItem;
